import OrganizationDetailsCard from "./OrganizationDetailsCard";

export default OrganizationDetailsCard;
